import httpUtil from "@/utils/httpUtil";

export const selectJob = params => httpUtil.get("/printJob", params);
export const getLotNumber = params => httpUtil.get("/printJob/getLotNumber", params);
export const getBatch = params => httpUtil.get("/printJob/getBatch", params);

export const addJob = params => httpUtil.post("/printJob", params);

